import styled from "@emotion/styled"
import TabSwitcher from "./TabSwitcher"
import { extractProperty } from "utils"
import { Desktop, Mobile, NewText, TitleWithLine } from "ui"
import colors from "theme/colors"

const StyledPersonsWrapper = styled.div`
  padding: 25px 20px 40px 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 60px 146px 60px 146px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 80px 220px 80px 220px;
  }
`

function Persons({ data, locale }: { data: any; locale: string }) {
  const title = extractProperty(data, "blockTitle")
  return (
    <StyledPersonsWrapper>
      <Desktop>
        <NewText
          component={"h2"}
          largeDesktopFontSize={64}
          largeDesktopLineHeight="80px"
          desktopFontSize={42}
          desktopLineHeight={"53.33px"}
          desktopFontWeight={500}
          mobileFontSize={36}
          mobileLineHeight={"50.4px"}
        >
          {title}
        </NewText>
      </Desktop>
      <Mobile>
        <TitleWithLine
          title={title}
          largeDesktopFontSize={64}
          largeDesktopLineHeight="80"
          titleFontSize={42}
          desktopLineHeight={"53.33px"}
          desktopFontWeight={500}
          mobileTitleFontSize={36}
          mobileLineHeight={"50.4px"}
          titleColor={colors.black}
        />
      </Mobile>
      <TabSwitcher data={data} locale={locale} />
    </StyledPersonsWrapper>
  )
}

export default Persons
